module.exports = __webpack_public_path__ + "img/product-sm-1.e150512e.png";